import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import myOrderService from "services/myOrderService";

export const useDetailMyOrder = (payload, onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation(["orders"]);

  return useQuery(["order-detail"], () => myOrderService.getOrder(payload), {
    enabled: false,
    retry: 1,
    refetchOnWindowFocus: false,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.fetch_profile", {
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
    // initialData: Object({ data: {} }),
    select: response => {
      const { data } = response;
      return data;
    },
  });
};

export const useCancelMyOrder = (onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation(["order"]);

  return useMutation(myOrderService.cancelOrder, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
      if (!!response["result"]) {
        addToast(
          t("message.cancel", {
            target: t("order"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
      } else {
        addToast(
          t("message.cancel", {
            target: t("order"),
            status: t("message.error"),
          }),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useCreateMyOrder = (onSuccess, onError) => {
  const { t } = useTranslation(["order"]);
  const { addToast } = useToasts();

  return useMutation(myOrderService.createOrder, {
    retry: 0,
    onSuccess: response => {
      const data = response;
      addToast(
        t("message.create", {
          target: t("order"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("order"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );

      if (errorResponse?.code === 422 && errorResponse?.fields.length > 0) {
        errorResponse.fields.forEach(item => {
          switch (item.field) {
            default:
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 15000,
              });
              break;
          }
        });
      }

      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Detail Customer Location By Order
/**
 * @param {object} data
 * @param {?*} [data.onSuccess]
 * @param {?*} [data.onError]
 */
export const useDetailCustomerLocationByOrder = ({ onSuccess, onError }) => {
  const { t } = useTranslation(["order"]);
  const { addToast } = useToasts();

  return useMutation({
    mutationFn: myOrderService.detailCustomerLocationByOrder,
    onSuccess: response => {
      const { data } = response;

      if (data?.result === false) {
        addToast(
          formConvertErrorMessage(
            data.message ||
              t("message.detail", {
                target: t("customer_location"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "warning",
            autoDismiss: true,
          }
        );
        return;
      }

      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.detail", {
              target: t("address_order"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
